import { FC, Fragment } from 'react'
import { useMemo } from 'react'

import useSWRImmutable from 'swr/immutable'
import type { EstoOption, ScheduleType } from '@api/checkout/esto/esto-utils'

import { useCartState } from '@components/cart/State/state'

import { useTranslate } from '@hooks/useTranslation'
import { CwsDivider, CwsP, CwsRadio, CwsH3 } from '@components/cws'

const levels: Record<ScheduleType, number> = {
  REGULAR: parseFloat(process.env.NEXT_PUBLIC_ESTO_REGULAR_LEVEL || '0'),
  ESTO_X: parseFloat(process.env.NEXT_PUBLIC_ESTO_ESTO_X_LEVEL || '0'),
  PAY_LATER: parseFloat(process.env.NEXT_PUBLIC_ESTO_PAY_LATER_LEVEL || '0'),
}

export const EstoOptions: FC = () => {
  const {
    dispatch,
    state: { order, paymentMethod, paymentTypeDetails },
  } = useCartState()
  const { data: options } = useSWRImmutable<EstoOption[]>('/api/payment/esto/methods')

  const { translate } = useTranslate()
  const orderTotal = useMemo(() => order?.totalIncTax, [order])

  if (!orderTotal) return null

  return (
    <>
      <CwsH3>{translate('cart.payment.esto.title')}</CwsH3>
      {options &&
        options.map((item, index) => {
          const isFirst = index === options.length - 1
          const disabled = !(orderTotal >= levels[item.schedule_type])
          return (
            <Fragment key={item.name}>
              <CwsRadio
                label={item.name}
                checked={paymentMethod === 'esto' && paymentTypeDetails === item.key}
                value={item.name}
                onClick={() => {
                  dispatch({
                    type: 'setPaymentTypeDetails',
                    payload: item.key,
                  })
                  dispatch({ type: 'setPaymentMethod', payload: 'esto' })
                }}
                disabled={disabled}
              >
                {translate(`esto.${item.key}.lbl`)}
              </CwsRadio>
              <CwsP
                size="small"
                className="cws-pl-32 cws-ml-2"
                dangerouslySetInnerHTML={{ __html: translate(`esto.${item.key}.info`) }}
              ></CwsP>
              {!isFirst && <CwsDivider className="cws-mx-0" />}
            </Fragment>
          )
        })}
    </>
  )
}

export default EstoOptions
